import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportPropertyDetailConstant } from '../../residential-property/residential-property-detail.constant';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';

@Component({
  selector: 'app-commercial-rental-income-assessment',
  templateUrl: './commercial-rental-income-assessment.component.html',
  styleUrls: ['./commercial-rental-income-assessment.component.scss']
})
export class CommercialRentalIncomeAssessmentComponent {
  @Output() isEmpatyCheck: any = new EventEmitter();
  rentalIncomeAreaLoading = false;
  rentalIncomeAreaData = [];
  rentalIncomeAreaCount = 0;
  rentalIncomeAreaColumns  = ReportPropertyDetailConstant.rentalIncomeArea;
  placeCode: any;
  @Input() propertyInfo: any;
  constructor(public reportPropertyDetailService: ReportPropertyDetailService,
      private reportService: ReportService, private sharedService: SharedService
    ){
      this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
          //Update Column Monthly/Annual
          if (this.sharedService.priceCalculation$() === this.sharedService.priceYearly) {
            const columnsToUpdateOne = [
              { header: 'rental_price', columnName: 'reports.yearly_rentals' }
            ];
            columnsToUpdateOne.forEach(column => {
              const targetColumn = this.rentalIncomeAreaColumns.find(x => x.header === column.header);
              if (targetColumn) {
                targetColumn.columnName = column.columnName;
              }
            });
          }
    }

  ngOnInit() { }
  ngOnChanges() {
    this.sharedService.language$.subscribe({
      next : (res: any) => {
          this.getRentalIncomeArea();
      },
      error : (err:any) => { }
    })
  }
  getRentalIncomeArea() {
    this.rentalIncomeAreaLoading = true;
    this.reportPropertyDetailService.getRentalIncomeAreaReport(this.reportPropertyDetailService.rentalIncomeAreaPayload).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.isEmpatyCheck.emit(true);
            res.data.map((el:any)=>{
              Object.keys(el).map((e:any)=>{
                if(['lease_rate', 'rental_price'].includes(e)){
                  el[e] = this.reportService.rangeToNumberFor(el[e]);
                }
              })
            })
           this.rentalIncomeAreaData = res.data;
            if(this.reportPropertyDetailService.rentalIncomeAreaPayload.pageNumber == 0){
            this.rentalIncomeAreaCount = res.count;
           }
          } else {
            this.isEmpatyCheck.emit(false);
            this.rentalIncomeAreaData = [];
            this.rentalIncomeAreaCount = 0;
          }
          this.rentalIncomeAreaLoading = false;
        },
        error:()=>{
          this.isEmpatyCheck.emit(false);
          this.rentalIncomeAreaLoading = false;
          this.rentalIncomeAreaData = [];
          this.rentalIncomeAreaCount = 0;
        }
      }
    )
  }

  sortData(event: any) {
    let sort = {
      column: (event.active == 'ir_lease_rate') ? 'lease_rate': event.active,
      order: event.direction
    }
    this.reportPropertyDetailService.rentalIncomeAreaPayload.pageNumber = 0;
    this.reportPropertyDetailService.rentalIncomeAreaPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    this.getRentalIncomeArea();
  }

  downloadExcel(type:string) {
    this.reportPropertyDetailService.downloadRentalReport("property_details_commercial_rental_income", 'residential', this.propertyInfo.property_uid, 'e');
  }

}
